<template>
  <div class="monitor">
    <div class="monitor-left">
      <el-alert
        class="title"
        title="添加"
        type="success"
        :closable="false"
      />
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="重点词">
          <el-input v-model="form.special_word" size="mini" />
        </el-form-item>
      </el-form>
      <div class="btns">
        <base-upload  @txtContent="getTxtContent" />
        <el-button type="primary" size="small">批量导入</el-button>
        <el-button type="primary" size="small" @click="add">添加</el-button>
      </div>
    </div>
    <div class="monitor-right">
      <el-alert
        class="title"
        title="查询"
        type="success"
        :closable="false"
      />
      <el-row :gutter="20">
        <el-col :span="18">
          <el-input v-model="query"  size="mini" />
        </el-col>
        <el-col :span="6">
          <el-button size="mini" @click="handleQuery">查询</el-button>
        </el-col>
      </el-row>
      <base-table
        :tableTitle="tableTitle"
        :tableData="tableData"
      >
        <template v-slot:operation="{ rowDate }">
          <el-button type="primary" size="mini" @click="showDialog(rowDate)">修改</el-button>
          <el-button type="danger" size="mini" @click="removeRow(rowDate)">删除</el-button>
        </template>
      </base-table>
      <base-pagination
        :total.sync="params.total"
        :page.sync="params.page"
        :limit.sync="params.size"
        @pagination="changePage"
      />
    </div>
    <!-- 弹窗 -->
    <base-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :formRules="dialog.formRules"
      :formData.sync="dialog.params"
      @submit="updateSubmit"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable/index';
import BasePagination from '@/components/BasePagination/index';
import BaseDialog from '@/components/BaseDialog/index';
import BaseUpload from '@/components/BaseUpload/index';
import {
  getMonitor,
  deleteMonitor,
  addMonitor,
  modifyMonitor,
} from '@/api/index';

export default {
  name: 'monitor',
  data() {
    return {
      form: {
        special_word: '',
      },
      query: '',
      userJson: {},
      tableTitle: [ {
        label: '重点词',
        prop: 'special_word',
      },
      {
        label: '添加时间',
        prop: 'add_time',
      },
      {
        label: '操作',
        prop: 'operation',
        width: 150
      }],
      tableData: [],
      params: {
        total: 0,
        page: 1,
        size: 10,
      },
      dialog: {
        title: '重点监控修改',
        visible: false,
        formRules: [{
          name: '旧重点词',
          prop: 'special_word',
          inputType: 'text',
          disabled: true,
        },
        {
          name: '新重点词',
          prop: 'new_special_word',
          inputType: 'text',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        }],
        params: {
          cspecial_word: '',
          new_special_word: '',
        },
      }
    };
  },
  components: {
    BaseTable,
    BasePagination,
    BaseDialog,
    BaseUpload,
  },
  created() {
    this.$nextTick(() => {
      const { wps } = localStorage;
      this.userJson = JSON.parse(wps);
      this.getList();
    })
  },
  methods: {
    handleQuery() {
      this.params = {
        total: 0,
        page: 1,
        size: 10,
      }
      this.tableData = [];
      this.getList();
    },
    async getList() {
      const res = await getMonitor({
        word: this.query,
        page_no: this.params.page,
        token: this.userJson.token,
      });
      this.tableData = res || [];
    },
    async add() {
      const res = await addMonitor({
        ...this.form,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      }
      this.params.page = 1;
      this.getList();
    },
     async removeRow(row) {
      const { special_word } = row
      const res = await deleteMonitor({
        special_word,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      }
      this.getList();
    },
    changePage() {
      this.getList();
    },
    async updateSubmit(val) {
      const {
        special_word,
        new_special_word,
      } = val;
      const res = await modifyMonitor({
        special_word,
        new_special_word,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
        this.dialog.visible = false;
      }
      this.getList();
    },
    showDialog(row) {
      const { special_word } = row
      this.dialog = {
        ...this.dialog,
        visible: true,
        params: {
          ...row,
          new_special_word: special_word,
        }
      }
    },
    getTxtContent(list) {
      list.forEach((item) => {
        this.import_(item);
      });
    },
    async import_(item) {
      if(item.length < 0) {
        this.$message({
          message: '文件格式错误！',
          type: 'error'
        })
        return;
      }
      const res = await addMonitor({
        special_word: item[0],
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });

      if(res.return_code == 1) {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
      this.params.page = 1;
      this.getList();
    },
  }
};
</script>

<style scoped>
.monitor {
  height: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  color: black;
}

.monitor-left  {
  flex: 1;
}

.monitor-right {
  /* padding-left: 30px; */
  width: 55%;
}

.monitor-left  {
  margin-right: 50px;
}

.title {
  margin-bottom: 12px;
}
::v-deep .el-textarea__inner {
  min-height: 200px!important;
}

.btns {
  display: flex;
  justify-content: flex-end;
}
</style>